import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28f41b08"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ding-group-config-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ding-group-config-page__hint" }, " 业务组群请填写组节点部门ID，组下投教等子部门成员会自动路由到该群。 ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ding-group-config-page__hint" }, " 启用前须配置有效 Webhook。 ", -1))

import {
  computed,
  onBeforeUnmount,
  onMounted,
  reactive,
  ref,
  shallowRef
} from 'vue'
import {
  ElAlert,
  ElForm,
  ElSelect,
  ElOption,
  ElMessage,
  ElMessageBox
} from 'element-plus'
import { CrudDialog, CrudTable } from '@/components/crud-v2'
import { usePermission } from '@/hooks/usePermission'
import { dingGroupColumns } from './ding-group-config.config'
import {
  createDingGroupConfig,
  deleteDingGroupConfig,
  fetchDingGroupConfigs,
  updateDingGroupConfig
} from './ding-group-config.service'
import type {
  DingGroupConfig,
  DingGroupConfigPayload
} from './ding-group-config.service'

type FormRef = InstanceType<typeof ElForm>

export default /*#__PURE__*/_defineComponent({
  __name: 'DingGroupConfig',
  setup(__props) {

const canList = usePermission('dingGroupConfig', 'list')
const canCreate = usePermission('dingGroupConfig', 'create')
const canUpdate = usePermission('dingGroupConfig', 'update')
const canDelete = usePermission('dingGroupConfig', 'delete')
const columns = computed(() =>
  canUpdate || canDelete
    ? dingGroupColumns
    : dingGroupColumns.filter((column) => column.slot !== 'rowActions')
)
const records = ref<DingGroupConfig[]>([])
const loading = ref(false)
const errorMessage = ref('')
let requestController: AbortController | undefined

async function load() {
  if (!canList) return
  requestController?.abort()
  const controller = new AbortController()
  requestController = controller
  loading.value = true
  errorMessage.value = ''
  try {
    const data = await fetchDingGroupConfigs(controller.signal)
    if (!controller.signal.aborted) records.value = data
  } catch (cause) {
    if (!controller.signal.aborted) {
      errorMessage.value = cause instanceof Error ? cause.message : '加载失败'
    }
  } finally {
    if (!controller.signal.aborted) loading.value = false
  }
}

const dialogVisible = ref(false)
const editingItem = shallowRef<DingGroupConfig>()
const dialogTitle = computed(() =>
  editingItem.value ? '编辑钉钉群配置' : '新增钉钉群配置'
)
const formRef = ref<FormRef>()
const createForm = (): DingGroupConfigPayload => ({
  groupName: '',
  dingDeptId: '',
  dingDeptName: '',
  routeType: 1,
  enabled: 0,
  webhook: '',
  secret: '',
  remark: ''
})
const form = reactive(createForm())
const rules = {
  groupName: {
    required: true,
    whitespace: true,
    message: '请输入群名称',
    trigger: 'blur'
  },
  routeType: {
    required: true,
    type: 'enum',
    enum: [1, 2],
    message: '请选择路由类型',
    trigger: 'change'
  },
  enabled: {
    required: true,
    type: 'enum',
    enum: [0, 1],
    message: '请选择状态',
    trigger: 'change'
  }
}

function openCreate() {
  editingItem.value = undefined
  Object.assign(form, createForm())
  dialogVisible.value = true
}

function openEdit(row: DingGroupConfig) {
  editingItem.value = row
  Object.assign(form, {
    groupName: row.groupName,
    dingDeptId: row.dingDeptId,
    dingDeptName: row.dingDeptName,
    routeType: row.routeType,
    enabled: row.enabled,
    webhook: '',
    secret: '',
    remark: row.remark
  })
  dialogVisible.value = true
}

async function submitForm() {
  const valid = await new Promise<boolean>((resolve) =>
    formRef.value!.validate(resolve)
  )
  if (!valid) return false
  if (editingItem.value) {
    await updateDingGroupConfig(editingItem.value.id, { ...form })
  } else {
    await createDingGroupConfig({ ...form })
  }
  return true
}

function handleSuccess() {
  ElMessage.success(editingItem.value ? '修改成功' : '新增成功')
  load()
}

function handleError(cause: unknown) {
  ElMessage.error(cause instanceof Error ? cause.message : '操作失败')
}

function clearCredentials() {
  form.webhook = ''
  form.secret = ''
}

const deletingId = ref<DingGroupConfig['id']>()
async function handleDelete(row: DingGroupConfig) {
  try {
    await ElMessageBox.confirm(
      `确认删除钉钉群“${row.groupName}”吗？删除后该部门或告警群将无法路由，建议优先使用停用。`,
      '删除钉钉群配置',
      {
        type: 'warning',
        confirmButtonText: '确认删除',
        cancelButtonText: '取消'
      }
    )
  } catch {
    return
  }
  deletingId.value = row.id
  try {
    await deleteDingGroupConfig(row.id)
    ElMessage.success('删除成功')
    await load()
  } catch (cause) {
    handleError(cause)
  } finally {
    deletingId.value = undefined
  }
}

onMounted(load)
onBeforeUnmount(() => requestController?.abort())

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(canList))
      ? (_openBlock(), _createBlock(_unref(ElAlert), {
          key: 0,
          title: "暂无钉钉群配置查询权限",
          type: "warning",
          closable: false
        }))
      : (_openBlock(), _createBlock(_unref(CrudTable), {
          key: 1,
          rows: records.value,
          columns: columns.value,
          loading: loading.value,
          "error-message": errorMessage.value,
          "page-no": 1,
          "page-size": records.value.length || 10,
          total: records.value.length,
          "show-pagination": false,
          onRetry: load
        }, {
          title: _withCtx(() => [
            _createTextVNode("钉钉群配置")
          ]),
          actions: _withCtx(() => [
            (_unref(canCreate))
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "primary",
                  onClick: openCreate
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 新增 ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          enabled: _withCtx(({ row }) => [
            _createVNode(_component_el_tag, {
              type: row.enabled === 1 ? 'success' : 'info'
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(row.enabled === 1 ? '启用' : '停用'), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          rowActions: _withCtx(({ row }) => [
            (_unref(canUpdate))
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "text",
                  disabled: deletingId.value !== undefined,
                  onClick: ($event: any) => (openEdit(row))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("编辑")
                  ]),
                  _: 2
                }, 1032, ["disabled", "onClick"]))
              : _createCommentVNode("", true),
            (_unref(canDelete))
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  type: "text",
                  loading: deletingId.value === row.id,
                  disabled: deletingId.value !== undefined,
                  onClick: ($event: any) => (handleDelete(row))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("删除")
                  ]),
                  _: 2
                }, 1032, ["loading", "disabled", "onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["rows", "columns", "loading", "error-message", "page-size", "total"])),
    _createVNode(_unref(CrudDialog), {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((dialogVisible).value = $event)),
      title: dialogTitle.value,
      submit: submitForm,
      width: "min(640px, calc(100vw - 32px))",
      onSuccess: handleSuccess,
      onSubmitError: handleError,
      onClosed: clearCredentials
    }, {
      default: _withCtx(({ submitting }) => [
        _createVNode(_unref(ElForm), {
          ref_key: "formRef",
          ref: formRef,
          model: form,
          rules: rules,
          disabled: submitting,
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "群名称",
              prop: "groupName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.groupName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.groupName) = $event)),
                  placeholder: "请输入群名称"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "钉钉部门ID",
              prop: "dingDeptId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.dingDeptId,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.dingDeptId) = $event)),
                  placeholder: "请输入钉钉部门ID"
                }, null, 8, ["modelValue"]),
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "钉钉部门名称",
              prop: "dingDeptName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.dingDeptName,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.dingDeptName) = $event)),
                  placeholder: "请输入钉钉部门名称"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "路由类型",
              prop: "routeType"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElSelect), {
                  modelValue: form.routeType,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.routeType) = $event)),
                  style: {"width":"100%"},
                  placeholder: "请选择路由类型"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElOption), {
                      label: "常规",
                      value: 1
                    }),
                    _createVNode(_unref(ElOption), {
                      label: "兜底",
                      value: 2
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "状态",
              prop: "enabled"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElSelect), {
                  modelValue: form.enabled,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.enabled) = $event)),
                  style: {"width":"100%"},
                  placeholder: "请选择状态"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElOption), {
                      label: "停用",
                      value: 0
                    }),
                    _createVNode(_unref(ElOption), {
                      label: "启用",
                      value: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Webhook",
              prop: "webhook"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.webhook,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.webhook) = $event)),
                  type: "password",
                  "show-password": "",
                  autocomplete: "new-password",
                  placeholder: 
                editingItem.value ? '留空保持已有 Webhook' : '请输入 Webhook'
              
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Secret",
              prop: "secret"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.secret,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.secret) = $event)),
                  type: "password",
                  "show-password": "",
                  autocomplete: "new-password",
                  placeholder: 
                editingItem.value ? '留空保持已有 Secret' : '请输入 Secret'
              
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "备注",
              prop: "remark"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.remark,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.remark) = $event)),
                  type: "textarea",
                  rows: 3,
                  placeholder: "请输入备注"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 2
        }, 1032, ["model", "disabled"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})